import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PageHeader } from '../components/PageHeader';
import { EventCard } from '../components/EventCard';
import { CalendarDays } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function EventsPage() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        try {
            const response = await axios.get(`${API}/events`);
            // Sort events by date (support both field names)
            const sorted = response.data.sort((a, b) => {
                const dateA = new Date(a.date_time || a.start_date_time);
                const dateB = new Date(b.date_time || b.start_date_time);
                return dateA - dateB;
            });
            setEvents(sorted);
        } catch (error) {
            console.error('Error fetching events:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container" data-testid="events-page">
            <PageHeader title="What's On" />
            
            <div className="px-4 py-4">
                {/* Header Info */}
                <div className="card-base bg-primary/5 mb-6">
                    <div className="flex items-center gap-3">
                        <CalendarDays className="w-8 h-8 text-primary" />
                        <div>
                            <h2 className="font-bold text-foreground">Upcoming Events</h2>
                            <p className="text-muted-foreground text-sm">Tap an event for details</p>
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="flex justify-center items-center py-12">
                        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
                    </div>
                ) : (
                    <div className="space-y-4" data-testid="events-list">
                        {events.length === 0 ? (
                            <div className="card-base text-center py-8">
                                <CalendarDays className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                                <p className="text-muted-foreground">No upcoming events at the moment.</p>
                                <p className="text-sm text-muted-foreground mt-1">Check back soon!</p>
                            </div>
                        ) : (
                            events.map(event => (
                                <EventCard key={event.id} event={event} />
                            ))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default EventsPage;
